<template>
  <div class="insurance-price">
    <div v-if="insuranceData.Questions[0].Value">
      <div v-for="indbo in selectedPolicies(0)" :key="indbo.ID">
        <div class="row" v-if="indbo.ID === insuranceData.Questions[0].Value">
          <div class="col-md-9 col-9">
            {{ insuranceData.TotalInsurance }} pr. måned
          </div>
          <div class="col-md-3 col-3 text-right">
            {{ trimPremium(indbo.Premium) }} kr.
          </div>
        </div>
      </div>
    </div>
    <div v-if="insuranceData.Questions[1].Value">
      <div v-for="ulykke in selectedPolicies(1)" :key="ulykke.ID">
        <div class="row" v-if="ulykke.ID === insuranceData.Questions[1].Value">
          <div class="col-md-9 col-9">
            {{ insuranceData.TotalExtra }} pr. måned
          </div>
          <div class="col-md-3 col-3 text-right">
            {{ trimPremium(ulykke.Premium) }} kr.
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div
      class="row"
      v-if="
        insuranceData.Questions[0].Value && !insuranceData.Questions[1].Value
      "
    >
      <div class="col-md-9 col-9">
        {{ insuranceData.TotalInsurance }} pr. år
      </div>
      <div class="col-md-3 col-3 text-right">
        {{ yearlyHomeInsurancePrice }} kr.
      </div>
    </div>
    <div
      class="row"
      v-if="
        !insuranceData.Questions[0].Value && insuranceData.Questions[1].Value
      "
    >
      <div class="col-md-9 col-9">{{ insuranceData.TotalExtra }} pr. år</div>
      <div class="col-md-3 col-3 text-right">
        {{ yearlyAccidentInsurancePrice }} kr.
      </div>
    </div>
    <div
      class="row"
      v-if="
        insuranceData.Questions[0].Value && insuranceData.Questions[1].Value
      "
    >
      <div class="col-md-9 col-9">
        {{ insuranceData.TotalMonth }}
      </div>
      <div class="col-md-3 col-3 text-right">{{ getMonthlyPrice() }} kr.</div>
      <div class="col-md-9 col-9">
        {{ insuranceData.TotalYear }}
      </div>
      <div class="col-md-3 col-3 text-right">{{ getYearlyPrice() }} kr.</div>
    </div>
    <div
      class="row"
      v-if="
        insuranceData.Questions[0].Value || insuranceData.Questions[1].Value
      "
    >
      <div class="col-md-9 col-9">
        {{ insuranceData.FeeText }}
      </div>
      <div class="col-md-3 col-3 text-right">
        {{ insuranceData.FeeSum }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        homeInsurancePremium: 0,
        accidentInsurancePremium: 0,
      };
    },
    props: {
      insuranceData: {
        type: Object,
        required: true,
      },
    },
    methods: {
      trimPremium(premium) {
        return premium.slice(0, -2);
      },
      getMonthlyPrice() {
        return (
          parseInt(this.homeInsurancePremium) +
          parseInt(this.accidentInsurancePremium)
        );
      },
      getYearlyPrice() {
        return (
          this.yearlyHomeInsurancePrice + this.yearlyAccidentInsurancePrice
        );
      },
      selectedPolicies(insuranceCategory) {
        const { Options: options, Value: value } =
          this.insuranceData.Questions[insuranceCategory];
        const selectedInsurance = options.filter(
          (policyId) => policyId.ID === value
        );

        if (insuranceCategory === 0) {
          this.homeInsurancePremium = this.trimPremium(
            selectedInsurance[0].Premium
          );
        } else if (insuranceCategory === 1) {
          this.accidentInsurancePremium = this.trimPremium(
            selectedInsurance[0].Premium
          );
        }
        return selectedInsurance;
      },
    },
    computed: {
      yearlyHomeInsurancePrice() {
        return this.homeInsurancePremium * 12;
      },
      yearlyAccidentInsurancePrice() {
        return this.accidentInsurancePremium * 12;
      },
    },
  };
</script>
<style lang="scss">
  @media (max-width: 544px) {
    .insurance-price {
      font-family: Helvetica;
      font-size: 15px;
      letter-spacing: 0.5px;
      line-height: 24px;
    }
    .text-right {
      font-weight: bold;
    }
  }
</style>
